import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
// import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
// import Table from "../../../../components/Datatable/DataTable";
// import config from "../../../../config/config";
// import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../components/Modal/UnDeleteConfirmation";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import MaterialReactTable from "material-react-table";
import { checkUserPermission } from "../../../common/UserPermission";
import { Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const DeletedSuppliers = (props) => {
  let selectData = [];
  let PERMISSION_DELETE = "delete-customers";
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedSuppliersCheckboxIds, setselectedSuppliersCheckboxIds] =
    useState("");

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     setSelectedRows(e.selectedRows.map((x) => x.ID));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.ID);
  //     console.log(e.selectedRows.map((x) => x.ID));

  //     const selectedSuppliersCheckboxIds =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedSuppliersCheckboxIds(selectedSuppliersCheckboxIds);
  //     console.log(selectedSuppliersCheckboxIds);
  //   }
  // };

  // Get all tag data
  const handleListData = (globalFilter, pagination, sorting) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.suppliersBaseUrl
        }/suppliers/managedelete?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("DeletedData", res);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleListData(globalFilter, pagination, sorting);
  }, [globalFilter, pagination, sorting]);

  const handleDeletePopup = (rows) => {
    const data = rows.map((el) => el.original.ID).join(",");

    const deleteRequestParam = {
      supplierids: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const contextActions = useMemo(() => {
    const handleDeletePopup = () => {
      const deleteRequestParam = {
        supplierids: selectedSuppliersCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };
    return (
      <button
        type="button"
        className="btn btn-success btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#UnDeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Un Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  // Table Data
  // const columns = [
  //   {
  //     name: "ID",
  //     selector: "ID",
  //     sortable: true,
  //   },
  //   {
  //     name: "Name",
  //     selector: (row) => row.FirstName + " " + row.LastName,
  //     sortable: true,
  //   },
  //   {
  //     name: "E-Mail",
  //     selector: "Email",
  //     sortable: true,
  //   },
  //   {
  //     name: "Phone Number",
  //     selector: "PhoneNumber",
  //     sortable: true,
  //   },
  // ];

  const columns = useMemo(() => [
    {
      //     //     <div class="btn-group-sm" role="group" >
      //     //       {checkUserPermission(PERMISSION_EDIT) && (
      //     //         <Link className="btn btn-primary btn-sm btn-custom-padding"
      //     //           to={`/manage-customers/${row.Id}`}
      //     //           style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      //     //         >
      //     //           Edit
      //     //         </Link>
      //     //       )}
      //     //       {(checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE)) && (
      //     //         <>
      //     //           <button
      //     //             type="button"
      //     //             className="btn btn-outline-primary btn-sm dropdown-toggle btn-custom-padding"
      //     //             data-bs-toggle="dropdown"
      //     //             aria-haspopup="true"
      //     //             aria-expanded="false"
      //     //             style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      //     //           >
      //     //           </button>
      //     //           <div className="dropdown-menu">
      //     //             {checkUserPermission(PERMISSION_EDIT) ? (
      //     //               <li>
      //     //                 <Link className="dropdown-item me-3" to={`/manage-customers/${row.Id}`}>
      //     //                   <i className="fa fa-edit" title="Edit"></i>Edit
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //             {checkUserPermission(PERMISSION_DELETE) ? (
      //     //               <li>
      //     //                 <Link
      //     //                   className="dropdown-item confirm-text"
      //     //                   to="#"
      //     //                   title="Delete"
      //     //                   data-bs-toggle="modal"
      //     //                   data-bs-target="#DeleteConfirmationModal"
      //     //                   onClick={() => handleDeletePopup(row.Id)}
      //     //                 >
      //     //                   <i
      //     //                     className="fa fa-trash"
      //     //                     data-bs-toggle="tooltip"
      //     //                     title="Delete"
      //     //                   ></i>
      //     //                   Delete
      //     //                 </Link>
      //     //               </li>
      //     //             ) : (
      //     //               ""
      //     //             )}
      //     //           </div>
      //     //         </>
      //     //       )}
      //     //     </div>
      //     //   ),
      //     //   ignoreRowClick: true,
      //     //   allowOverflow: true,
      //     //   button: true,
      //     //   //width: "7%",//"100px",
      //     //   minWidth: "90px",
      //     //   width: "90px",
      //     // },
      //     // {
      //     //   name: "Company Name",
      //     //   selector: "CompanyName",
      //     //   sortable: true,
      //     //   width: "170px",
      //     //   cell: (row) => (

      //     //     <>
      //     //       {checkUserPermission(PERMISSION_EDIT) ?
      //     //         <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //     //           {row.CompanyName}
      //     //         </Link>
      //     //         :
      //     //         row.CompanyName
      //     //       }
      //        header: "Company Name",
      //       accessorKey: "CompanyName",
      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     {
      //       header: "Name",
      //       accessorKey: "Name",
      //       Cell: ({ row }) => (
      //         <>
      //           <Link class="text-warning" to={`/manage-customers/${row.Id}`}>
      //             {row.original.FirstName} {row.original.LastName}
      //           </Link>
      //         </>
      //       ),

      //       // enableGrouping: false, //do not let this column be grouped
      //     },
      //     // {
      //     //   header: "DATE",
      //     //   accessorKey: "DATE",
      //     //   Cell: ({row})=> moment(row.original.DATE).format('DD-MM-YYYY')
      //     // },
      //     {
      //       header: "E-Mail",
      //       accessorKey: "Email",
      //       Cell: ({ row }) => (
      //         <>
      //           <p title={row.original.Email}>{row.original.Email}</p>
      //         </>
      //       ),
      // =======
      header: "ID",
      accessorKey: "ID",
    },
    {
      header: "Name",
      accessorKey: "FirstName",
      Cell: ({ row }) => row.original.FirstName + " " + row.original.LastName,
    },
    {
      header: "E-Mail",
      accessorKey: "Email",
    },
    {
      header: "Phone Number",
      accessorKey: "PhoneNumber",
    },
  ]);

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };
  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
    console.log(handleListData);
  };
  // const rowSelectCritera = row => row.fat > 6;

  // const clickHandler = (e) => {
  //     console.log(e.target.id);
  // }
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Deleted Supplier</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/suppliers">Suppliers List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Deleted Suppliers List
                </li>
              </ul>
            </div>
          </div>

          <div className="row flex-row-reverse">
            {/* <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
              {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
            {/* </div>  */}
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {/* <DataTable
                  title="Deleted Supplier List"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                /> */}
                <MaterialReactTable
                  columns={columns}
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  // enableRowActions

                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}

                      {checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          size="small"
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          onClick={() =>
                            handleDeletePopup(table.getSelectedRowModel().rows)
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          Delete Selected
                        </Button>
                      ) : (
                        ""
                      )}
                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({
                            ...pagination,
                            pageIndex: 0,
                            pageSize: totalRows,
                          })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                  rowVirtualizerProps={{
                    overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                    estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 10 },
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100, 300],
                  }}
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}
                  // enableColumnVirtualization
                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.suppliersBaseUrl}/suppliers/undeletemutiple`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default DeletedSuppliers;
